import { IEwtCounts, IEwtSummary, IRecipient } from '../';
import { IMortalityCalculations } from '../'

export interface ITargetItem {
    recipientCenterId: number,
    recipientCenter: string,
    recipientId: number,
    recipientAlias: string,
    recipientBloodType: string,
    recipientIsExportable: boolean,
    oTiterString: string,
    donorBloodType: string,
    maxDonorAge: number,
    minHLAMatch: number,

    cPRA4: number,
    rAge: number,

    dAge: string,
    dmp: string,

    rmPa: number,
    rmPb: number,
    rmPc: number,

    pmPa: number,
    pmPb: number,
    pmPc: number,

    erosion: number,
    dialysis: string,
    dialysisMonths: number,

    ewt: string,
    wtv: string,

    wait: number,
    exportableDaysInNkr: number,

    onlyDonorIdMatchC: number,
    onlyDonorMatchCCenterId: number,
    onlyDonorMatchCAlias: string,
    onlyDonorMatchCCenter: string,
    rexmStatus: string,

    ewtSummary: IEwtSummary,
    initialCount: IEwtCounts,

    highPra: boolean,
    declineRatio: number,
    declineRatioCurrent: number,
    declineRatioHistoric: number,
    highestDeclineRatio: number,
    sortOrder: number,
    majorSort: number,
    minorSort: number

    // miracle match
    firstDonorBloodType: string,
    ssdHit: number,
    clc: number,
    fclc: number,
    usableCLC: number,
    donorInMatch: boolean,

    // targeted chain end
    transplantDate: string,

    recipientStatus: string,
    recipientStatusId: number,
    chainId: number,
    clCu: number,
    cprScore: number,
    cprScore2: number,

    monthsSince: number,

    kWait: number,
    aWait: number,
    tWait: number,
    isActive: boolean,
    surgeryDate: string,
    acceptedDonors: number,

    aboCombo: string,

    pediatric: boolean,
    isMatchable: boolean,

    adpStatus: string,
    adpType: string,
    adpSwapSaver: boolean,
    adpRtsf: boolean,

    // unmatched pair
    targetsWait: boolean,
    targetsClc: boolean,

    requireEpletId: number,
    requireEplet: string,
    requireEpletSortOrder: number,

    patientTypeId: number,
    patientType: string,

    isCompatiblePair: boolean,

    hardToMatch: boolean,
    isVoucherHolder: boolean,
    isPairedRecipient: boolean,

    donorsNeeded: number,
    donorCompatibleAbo: string,
    aboAndAgeCompatibleDonors: string,

    categories: IVoucherCategory[],

    policy: string,

    checked: boolean,

    withinTwoWeeks: boolean,

    potentialDonors: ITargetItemPotentialDonor[],
    forecastedWaitTime: string,
    oneYearMortalityRisk: number,
    mortalityCalculations: IMortalityCalculations
}

export interface ITargetItemPotentialDonor {
    id: number,
    centerId: number,
    center: string,
    alias: string,
    bloodType: string,
    age: number,
    type: string,
    donorInMatch: boolean
}

export interface IVoucherCategory {
    category: number,
    section: string,
    description: string,
    policy: string
}